module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"what_new":"Что у вас нового?.."}}')
  delete Component.options._Ctor
}
